import { useEffect, useState } from "react";
import Mensagens from "../Mensagens";
import { CanceledError } from "axios";

export function useFetch(api, initialData, { onRejected, formatter } = {}, cb) {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState(initialData);

  const listar = (_api, setLoaded) => {
    if (isLoading) return;

    setIsLoading(true);

    (_api instanceof Function ? _api : api)().then(function (response) {
      setIsLoading(false);
      let dados = response?.data;
      if (formatter) dados = formatter(dados);

      if (setLoaded instanceof Function) setLoaded(dados);
      else setFetchedData(dados);

      if (cb) cb(dados);
    }).catch(function (error) {
      setIsLoading(false);
      setFetchedData(initialData);

      const msg = error && error.response && error.response.status === 400 && error.response.data ? error.response.data : "Falha na conexão";
      if (onRejected) onRejected(msg);
      else Mensagens.showErro(msg);
    });
  };
  return [fetchedData, listar, isLoading, setFetchedData];
}

export function useSave(api, onSucess, { onRejected } = {}) {
  const [isSaving, setIsSaving] = useState(false);

  const save = (_api, _onSucess, options) => {
    if (isSaving) return;

    setIsSaving(true);

    const sucessCallback = _onSucess instanceof Function ? _onSucess : onSucess;
    const rejectCallback = options?.onRejected instanceof Function ? options.onRejected : onRejected;

    (_api instanceof Function ? _api : api)()
      .then(function (response) {

        if (sucessCallback) sucessCallback(response.data);
        else Mensagens.showSucesso("Gravado com sucesso!");
        setIsSaving(false);
      }).catch(function (error) {

        if (!(error instanceof CanceledError)) {
          const msg = error && error.response && error.response.status === 400 && error.response.data ? error.response.data : "Falha na conexão";

          if (rejectCallback) rejectCallback(msg, error);
          else Mensagens.showErro(msg);
        }

        setIsSaving(false);
      });
  };

  return [save, isSaving];
}

export function useVerificarStatus(logado, setConnectionStatus, fetch) {
  const [verificar] = useSave(() => fetch().post("/outros/status"), v => setConnectionStatus(v.status), { onRejected: () => setConnectionStatus(false) });

  useEffect(() => {

    if (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1')) {
      var interval = setInterval(() => {
        verificar();
      }, 60000);

      if (logado)
        verificar();
      else
        clearInterval(interval);

      return () => clearInterval(interval);
    }
    else
      setConnectionStatus(true);

  }, [logado]);
}
